import { useState } from "react";
import {
  getProducts,
  createProduct,
  editProductById,
  getProductById,
  deleteProductById,
  getCategories,
  getAttributes,
  getAllUOM,
  addCategories,
  deleteCategoryById,
  addUOMs,
  deleteUOMById,
  addAttributes,
  deleteAttributeById,
  fetchMakes,
  uploadProductExcel,
} from "../../../Services/productService";
import toast from "react-hot-toast";
import { extractErrorMessage } from "../../../Utils/extractErrorMessage";
import { TOAST_MESSAGES } from "../constants";

export const useProductMaster = () => {
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    search: null,
    category: null,
    product: null,
    make: null,
  });
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const onPageChange = (newPage) => setPage(newPage);
  const onPageSizeChange = (newSize) => {
    setRowsPerPage(newSize);
    setPage(1);
  };

  const [failedProducts, setFailedProducts] = useState([]);
  const [totalRows, setTotalRows] = useState(0);

  const fetchProducts = async (params) => {
    setLoading(true);
    let data = null;
    try {
      const response = await getProducts({
        ...filters,
        limit: rowsPerPage,
        offset: (page - 1) * rowsPerPage,
        ...params,
      });

      if (response.status === 200) {
        setTotalPages(
          Math.max(1, Math.ceil((response.data?.count || 0) / rowsPerPage))
        );
        data = response.data?.results ?? response.data;
      } else {
        const msg =
          extractErrorMessage(response) || TOAST_MESSAGES.FAILED_FETCH_PRODUCTS;
        toast.error(msg);
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.ERROR_FETCH_PRODUCTS
      );
    } finally {
      setLoading(false);
      return data;
    }
  };

  const createProductData = async (payload) => {
    setLoading(true);
    let data = null;
    try {
      const response = await createProduct(payload);
      if (response.status === 201) {
        toast.success(TOAST_MESSAGES.SUCCESS_CREATE_PRODUCT);
        data = response.data;
      } else {
        const msg =
          extractErrorMessage(response) || TOAST_MESSAGES.FAILED_CREATE_PRODUCT;
        toast.error(msg);
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.ERROR_CREATE_PRODUCT
      );
    } finally {
      setLoading(false);
      return data;
    }
  };

  const editProductData = async (id, payload) => {
    setLoading(true);
    let data = null;
    try {
      const response = await editProductById(payload, id);
      if (response.status === 200) {
        toast.success(TOAST_MESSAGES.SUCCESS_UPDATE_PRODUCT);
        data = response.data;
      } else {
        const msg =
          extractErrorMessage(response) || TOAST_MESSAGES.FAILED_UPDATE_PRODUCT;
        toast.error(msg);
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.ERROR_UPDATE_PRODUCT
      );
    } finally {
      setLoading(false);
      return data;
    }
  };

  const fetchProductById = async (id, warehouseId = null) => {
    setLoading(true);
    let data = null;
    try {
      const response = await getProductById(id, warehouseId);
      if (response.status === 200) {
        data = response.data;
      } else {
        const msg = extractErrorMessage(response) || TOAST_MESSAGES.FAILED_FETCH_PRODUCT;
        toast.error(msg);
      }
    } catch (error) {
      toast.error(extractErrorMessage(error) || TOAST_MESSAGES.ERROR_FETCH_PRODUCT);
    } finally {
      setLoading(false);
      return data;
    }
  };

  const deleteProductData = async (id) => {
    setLoading(true);
    let success = false;
    try {
      const response = await deleteProductById(id);
      if (response.status === 204) {
        toast.success(TOAST_MESSAGES.SUCCESS_DELETE_PRODUCT);
        success = true;
      } else {
        const msg =
          extractErrorMessage(response) || TOAST_MESSAGES.FAILED_DELETE_PRODUCT;
        toast.error(msg);
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.ERROR_DELETE_PRODUCT
      );
    } finally {
      setLoading(false);
      return success;
    }
  };

  const fetchCategories = async (params) => {
    setLoading(true);
    let data = null;
    try {
      const response = await getCategories({
        ...filters,
        limit: rowsPerPage,
        offset: (page - 1) * rowsPerPage,
        ...params,
      });
      if (response.status === 200) {
        setTotalPages(
          Math.max(1, Math.ceil((response.data?.count || 0) / rowsPerPage))
        );
        data = response.data?.results ?? response.data;
      } else {
        toast.error(
          extractErrorMessage(response) || TOAST_MESSAGES.FAILED_FETCH_CATEGORY
        );
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.FAILED_FETCH_CATEGORY
      );
    } finally {
      setLoading(false);
      return data;
    }
  };

  const fetchAttributes = async (params) => {
    setLoading(true);
    let data = null;
    try {
      const response = await getAttributes(params);
      if (response.status === 200) {
        data = response.data?.results ?? response.data;
      } else {
        toast.error(
          extractErrorMessage(response) ||
            TOAST_MESSAGES.FAILED_FETCH_ATTRIBUTES
        );
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.FAILED_FETCH_ATTRIBUTES
      );
    } finally {
      setLoading(false);
      return data;
    }
  };

  const getUOMs = async (params) => {
    setLoading(true);
    let data = null;
    try {
      const response = await getAllUOM({
        ...filters,
        limit: rowsPerPage,
        offset: (page - 1) * rowsPerPage,
        ...params,
      });

      if (response.status === 200) {
        setTotalPages(
          Math.max(1, Math.ceil((response.data?.count || 0) / rowsPerPage))
        );
        data = response.data?.results ?? response.data;
      } else {
        const msg =
          extractErrorMessage(response) || TOAST_MESSAGES.FAILED_FETCH_UOM;
        toast.error(msg);
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.ERROR_FETCH_UOM
      );
    } finally {
      setLoading(false);
      return data;
    }
  };

  const addCategory = async (payload) => {
    setLoading(true);
    let data = null;
    try {
      const response = await addCategories(payload);
      if (response.status === 201) {
        toast.success(TOAST_MESSAGES.SUCCESS_CREATE_CATEGORY);
        data = response.data;
      } else {
        const msg =
          extractErrorMessage(response) || TOAST_MESSAGES.FAILED_CREATE_CATEGORY;
        toast.error(msg);
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.ERROR_CREATE_CATEGORY
      );
    } finally {
      setLoading(false);
      return data;
    }
  };

  const deleteCategory = async (id) => {
    setLoading(true);
    let success = false;
    try {
      const response = await deleteCategoryById(id);
      if (response.status === 204) {
        toast.success(TOAST_MESSAGES.SUCCESS_DELETE_CATEGORY);
        success = true;
      } else {
        const msg =
          extractErrorMessage(response) || TOAST_MESSAGES.FAILED_DELETE_CATEGORY;
        toast.error(msg);
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.ERROR_DELETE_CATEGORY
      );
    } finally {
      setLoading(false);
      return success;
    }
  };

  const addUOM = async (payload) => {
    setLoading(true);
    let data = null;
    try {
      const response = await addUOMs(payload);
      if (response.status === 201) {
        toast.success(TOAST_MESSAGES.SUCCESS_CREATE_UOM);
        data = response.data;
      } else {
        const msg =
          extractErrorMessage(response) || TOAST_MESSAGES.FAILED_CREATE_UOM;
        toast.error(msg);
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.ERROR_CREATE_UOM
      );
    } finally {
      setLoading(false);
      return data;
    }
  };

  const deleteUOM = async (id) => {
    setLoading(true);
    let success = false;
    try {
      const response = await deleteUOMById(id);
      if (response.status === 204) {
        toast.success(TOAST_MESSAGES.SUCCESS_DELETE_UOM);
        success = true;
      } else {
        const msg =
          extractErrorMessage(response) || TOAST_MESSAGES.FAILED_DELETE_UOM;
        toast.error(msg);
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.ERROR_DELETE_UOM
      );
    } finally {
      setLoading(false);
      return success;
    }
  };

  const addAttribute = async (payload) => {
    setLoading(true);
    let data = null;
    try {
      const response = await addAttributes(payload);
      if (response.status === 201) {
        toast.success(TOAST_MESSAGES.SUCCESS_CREATE_UOM);
        data = response.data;
      } else {
        const msg =
          extractErrorMessage(response) || TOAST_MESSAGES.FAILED_CREATE_UOM;
        toast.error(msg);
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.ERROR_CREATE_UOM
      );
    } finally {
      setLoading(false);
      return data;
    }
  };

  const deleteAttribute = async (id) => {
    setLoading(true);
    let success = false;
    try {
      const response = await deleteAttributeById(id);
      if (response.status === 204) {
        toast.success(TOAST_MESSAGES.SUCCESS_DELETE_UOM);
        success = true;
      } else {
        const msg =
          extractErrorMessage(response) || TOAST_MESSAGES.FAILED_DELETE_UOM;
        toast.error(msg);
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.ERROR_DELETE_UOM
      );
    } finally {
      setLoading(false);
      return success;
    }
  };

  const getAllMakes = async (params) => {
    setLoading(true);
    let data = null;
    try {
      const response = await fetchMakes({
        ...filters,
        limit: rowsPerPage,
        offset: (page - 1) * rowsPerPage,
        ...params,
      });
      if (response.status === 200) {
        setTotalPages(
          Math.max(1, Math.ceil((response.data?.count || 0) / rowsPerPage))
        );
        let results = response.data?.results ?? response.data;
        if (params?.search) {
          const searchLower = params.search.toLowerCase();
          results = results.filter(
            (item) => item.make?.toLowerCase().includes(searchLower)
          );
        }
        data = results;
      } else {
        toast.error(
          extractErrorMessage(response) || TOAST_MESSAGES.FAILED_FETCH_MAKE
        );
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.FAILED_FETCH_MAKE
      );
    } finally {
      setLoading(false);
      return data;
    }
  };

  // Upload Excel for bulk product creation
  const uploadProductsFile = async (file) => {
    if (!file) return;
    setLoading(true);
    try {
      const res = await uploadProductExcel(file);

      if (res.status === 201) {
        toast.success(TOAST_MESSAGES.PRODUCTS_ADDED);
      } else if (res.status === 207) {
        setFailedProducts(res.data.skipped_rows || []);
        setTotalRows(res.data.total_rows || 0);
        toast.error(TOAST_MESSAGES.PRODUCTS_FAILED_TO_ADD);
      } else {
        const msg =
          extractErrorMessage(res) ||TOAST_MESSAGES.FAILED_ADD_PRODUCT
        toast.error(msg);
      }
    } catch (err) {
      const msg =
        extractErrorMessage(err) || TOAST_MESSAGES.ERROR_ADD_PRODUCT;
      toast.error(msg);
    } finally {
      setLoading(false);
      fetchProducts();
    }
  };

  return {
    loading,
    filters,
    setFilters,
    page,
    totalPages,
    rowsPerPage,
    setPage,
    setTotalPages,
    setRowsPerPage,
    onPageChange,
    onPageSizeChange,
    fetchProducts,
    createProductData,
    editProductData,
    fetchProductById,
    deleteProductData,
    fetchAttributes,
    fetchCategories,
    getUOMs,
    addCategory,
    deleteCategory,
    addUOM,
    deleteUOM,
    addAttribute,
    deleteAttribute,
    getAllMakes,
    uploadProductsFile,
  };
};
